/**
 * Custom Product Lightbox - Fast & Instant Slide Changes - OPTIMIZED
 */

class ProductLightbox {
  constructor() {
    this.lightbox = null;
    this.mainImage = null;
    this.imageWrapper = null;
    this.currentIndex = 0;
    this.images = [];
    this.thumbnailElements = [];
    this.preloadedImages = [];
    this.galleryContainer = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchStartTime = 0;
    this.hasMoved = false;
    this.isMovingForward = true;
  }

  init() {
    this.setupLightbox();
    this.waitForGallery();
  }

  waitForGallery() {
    const checkGallery = setInterval(() => {
      const container = document.querySelector('.product__media-list, .product-gallery, .product__media-wrapper');
      
      if (container) {
        clearInterval(checkGallery);
        this.galleryContainer = container;
        this.loadImages();
        this.bindGalleryDelegation();
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkGallery), 5000);
  }

  setupLightbox() {
    if (document.getElementById('customLightbox')) {
      this.lightbox = document.getElementById('customLightbox');
      this.mainImage = document.getElementById('lightboxImage');
      this.imageWrapper = document.querySelector('.lightbox-image-wrapper');
      return;
    }

    const style = document.createElement('style');
    style.textContent = `
      .product-gallery-item, .product-gallery-item * { cursor: pointer !important; }
      
      /* KILL scrollbar completamente */
      .custom-lightbox * {
        -ms-overflow-style: none !important;
        scrollbar-width: none !important;
      }

      .custom-lightbox *::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      
      /* FORZAR ocultar scrollbar en TODOS lados */
      .lightbox-image-wrapper {
        -ms-overflow-style: none !important;
        scrollbar-width: none !important;
        overflow: scroll !important;
      }
      
      .lightbox-image-wrapper::-webkit-scrollbar {
        display: none !important;
        width: 0px !important;
        height: 0px !important;
        background: transparent !important;
        -webkit-appearance: none !important;
      }
      
      .lightbox-image-wrapper::-webkit-scrollbar-thumb {
        display: none !important;
        background: transparent !important;
      }
      
      .lightbox-image-wrapper::-webkit-scrollbar-track {
        display: none !important;
        background: transparent !important;
      }
      
      /* Navegación fluida en móvil/tablet CON DRAG */
      @media screen and (max-width: 1023px) {
        .lightbox-image-wrapper {
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-x pan-y !important;
        }
        
        .lightbox-image {
          width: 300% !important;
          max-width: 300% !important;
          object-fit: contain !important;
        }
        
        /* Ocultar thumbnails en móvil/tablet */
        .lightbox-thumbnails {
          display: none !important;
        }
      }
      
      /* Desktop zoom normal */
      @media screen and (min-width: 1024px) {
        .lightbox-image-wrapper.show-zoom-cursor {
          cursor: zoom-in !important;
        }
      }
    `;
    document.head.appendChild(style);

    const html = `
      <div class="custom-lightbox" id="customLightbox">
        <button class="lightbox-close" id="lightboxClose">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
        
        <div class="lightbox-thumbnails" id="lightboxThumbnails"></div>
        
        <div class="lightbox-image-wrapper">
          <img src="" alt="" id="lightboxImage" class="lightbox-image">
        </div>
        
        <button class="lightbox-nav lightbox-nav-prev" id="lightboxPrev">
          <svg width="16" fill="none" aria-hidden="true" class="icon icon--direction-aware" viewBox="0 0 16 18">
            <path stroke="currentColor" stroke-linecap="square" d="M11 1 3 9l8 8"/>
          </svg>
        </button>
        <button class="lightbox-nav lightbox-nav-next" id="lightboxNext">
          <svg width="16" fill="none" aria-hidden="true" class="icon icon--direction-aware" viewBox="0 0 16 18">
            <path stroke="currentColor" stroke-linecap="square" d="m5 17 8-8-8-8"/>
          </svg>
        </button>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
    this.lightbox = document.getElementById('customLightbox');
    this.mainImage = document.getElementById('lightboxImage');
    this.imageWrapper = document.querySelector('.lightbox-image-wrapper');
    
    this.bindLightboxEvents();
  }

  loadImages() {
    const items = document.querySelectorAll('.product-gallery-item');
    
    this.images = [];
    this.preloadedImages = [];
    
    items.forEach((item, i) => {
      const img = item.querySelector('img');
      if (!img) return;
      
      let src = img.src.split('?')[0];
      const zoom = item.querySelector('.product-gallery-item__zoom');
      if (zoom && zoom.dataset.image) {
        src = zoom.dataset.image;
      }
      
      this.images.push({
        src: src,
        alt: img.alt || ''
      });
      
      const preload = new Image();
      preload.src = src;
      this.preloadedImages.push(preload);
    });
    
    this.buildThumbnails();
  }

  buildThumbnails() {
    const container = document.getElementById('lightboxThumbnails');
    if (!container) return;
    
    container.innerHTML = '';
    this.thumbnailElements = [];
    
    this.images.forEach((img, i) => {
      const thumb = document.createElement('div');
      thumb.className = 'lightbox-thumbnail';
      thumb.innerHTML = `<img src="${img.src}" alt="${img.alt}">`;
      thumb.dataset.index = i;
      container.appendChild(thumb);
      this.thumbnailElements.push(thumb);
      
      thumb.addEventListener('click', (e) => {
        e.stopPropagation();
        this.goTo(i);
      });
    });
  }

  bindGalleryDelegation() {
    if (!this.galleryContainer) return;
    
    this.galleryContainer.addEventListener('touchstart', (e) => {
      const item = e.target.closest('.product-gallery-item');
      if (!item) return;
      
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchStartTime = Date.now();
      this.hasMoved = false;
    }, { passive: true, capture: true });
    
    this.galleryContainer.addEventListener('touchmove', (e) => {
      const item = e.target.closest('.product-gallery-item');
      if (!item) return;
      
      const deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);
      
      if (deltaX > 10 || deltaY > 10) {
        this.hasMoved = true;
      }
    }, { passive: true, capture: true });
    
    this.galleryContainer.addEventListener('touchend', (e) => {
      const item = e.target.closest('.product-gallery-item');
      if (!item) return;
      
      const touchEndTime = Date.now();
      const deltaTime = touchEndTime - this.touchStartTime;
      
      if (!this.hasMoved && deltaTime < 300) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const items = Array.from(document.querySelectorAll('.product-gallery-item'));
        const index = items.indexOf(item);
        
        if (index !== -1) {
          this.loadImages();
          this.open(index);
        }
      }
    }, { passive: false, capture: true });
    
    this.galleryContainer.addEventListener('click', (e) => {
      if ('ontouchstart' in window) return;
      
      const item = e.target.closest('.product-gallery-item');
      if (!item) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const items = Array.from(document.querySelectorAll('.product-gallery-item'));
      const index = items.indexOf(item);
      
      if (index !== -1) {
        this.loadImages();
        this.open(index);
      }
    }, { capture: true });
  }

  bindLightboxEvents() {
    const closeBtn = document.getElementById('lightboxClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.close();
      });
    }
    
    // Click para cerrar SOLO en desktop
    if (this.imageWrapper) {
      this.imageWrapper.addEventListener('click', (e) => {
        // Deshabilitar cierre con click en móvil/tablet
        if (window.innerWidth <= 1023) return;
        
        if (e.target === this.imageWrapper || e.target === this.mainImage) {
          this.close();
        }
      });
    }

    const prevBtn = document.getElementById('lightboxPrev');
    const nextBtn = document.getElementById('lightboxNext');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.prev();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.next();
      });
    }

    if (this.imageWrapper) {
      this.imageWrapper.addEventListener('mousemove', (e) => {
        if (!this.lightbox.classList.contains('active')) return;
        
        const rect = this.imageWrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const xPercent = x / rect.width;
        const yPercent = y / rect.height;
        
        const maxScrollX = this.imageWrapper.scrollWidth - this.imageWrapper.clientWidth;
        const maxScrollY = this.imageWrapper.scrollHeight - this.imageWrapper.clientHeight;
        
        this.imageWrapper.scrollLeft = maxScrollX * xPercent;
        this.imageWrapper.scrollTop = maxScrollY * yPercent;
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!this.lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });
  }

  centerImage() {
    if (!this.imageWrapper) return;
    const maxScrollX = this.imageWrapper.scrollWidth - this.imageWrapper.clientWidth;
    this.imageWrapper.scrollLeft = maxScrollX / 2;
    this.imageWrapper.scrollTop = 0;
  }

  open(index) {
    this.currentIndex = index;
    this.isMovingForward = true;
    this.lightbox.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    this.updateImage();
    this.updateButtons();
    this.updateThumbnails();
    
    requestAnimationFrame(() => {
      this.lightbox.classList.add('active');
      this.centerImage();
      
      setTimeout(() => {
        if (this.imageWrapper) {
          this.imageWrapper.classList.add('show-zoom-cursor');
        }
      }, 250);
    });
  }

  goTo(index) {
    if (index < 0 || index >= this.images.length) return;
    this.currentIndex = index;
    
    this.updateImage();
    this.updateButtons();
    this.updateThumbnails();
    this.centerImage();
  }

  close() {
    if (this.imageWrapper) {
      this.imageWrapper.classList.remove('show-zoom-cursor');
    }
    
    this.lightbox.classList.remove('active');
    
    setTimeout(() => {
      this.lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }, 250);
  }

  prev() {
    if (this.currentIndex > 0) {
      this.isMovingForward = false;
      this.goTo(this.currentIndex - 1);
    }
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.isMovingForward = true;
      this.goTo(this.currentIndex + 1);
    }
  }

  updateImage() {
    if (this.preloadedImages[this.currentIndex] && this.preloadedImages[this.currentIndex].complete) {
      this.mainImage.src = this.preloadedImages[this.currentIndex].src;
    } else {
      this.mainImage.src = this.images[this.currentIndex].src;
    }
    this.mainImage.alt = this.images[this.currentIndex].alt;
  }

  updateThumbnails() {
    // Actualizar thumbnails
    this.thumbnailElements.forEach((thumb, i) => {
      if (i === this.currentIndex) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
  }

  updateButtons() {
    const prevBtn = document.getElementById('lightboxPrev');
    const nextBtn = document.getElementById('lightboxNext');
    
    if (!prevBtn || !nextBtn) return;
    
    const isFirst = this.currentIndex === 0;
    const isLast = this.currentIndex === this.images.length - 1;
    const hasMultiple = this.images.length > 1;
    
    if (!hasMultiple) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else if (isFirst) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'flex';
      this.isMovingForward = true;
    } else if (isLast) {
      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'none';
      this.isMovingForward = false;
    } else {
      if (this.isMovingForward) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'flex';
      } else {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'none';
      }
    }
  }
}

// Initialize once
if (!window.productLightboxInstance) {
  window.productLightboxInstance = new ProductLightbox();
  window.productLightboxInstance.init();
}